export default __webpack_public_path__ + "static/media/icon_chevron_left.f52f0d16.svg";